// extracted by mini-css-extract-plugin
export default {"wrapper":"PreviewPanel_wrapper__oIub2","header":"PreviewPanel_header__QHL1Y"};